import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import AdminError from '../../../components/admin/admin-error';
import AdminTextInput from '../../../components/admin/admin-text-input.js';
import MediaUploader from '../../../components/media/MediaUploader.js';
import { ContestItem } from './ContestItem';
import "react-datepicker/dist/react-datepicker.css";
import { showLoading, hideLoading } from '../../../store/loading-reducer';
import { addUpdateContest, getContestByBaseId } from '../../../api/contest';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { useAdminMenuContext } from "../../../context/AdminMenuContext";
import { getContestTypes } from '../../../store/contest/actions';
import { getCompanies } from '../../../store/employee/actions';

const ckEditorConfig = {
    toolbar: [
        'Bold',
        'Italic',
        'Link',
        'Unlink',
        'NumberedList',
        'BulletedList',
        'ImageUpload',
        'doclibrary'
    ],
    link: {
        decorators: {
            openInNewTab: {
                mode: 'manual',
                label: 'Open in a new tab',
                attributes: {
                    target: '_blank',
                    rel: 'noopener noreferrer'
                }
            },
        },
        addTargetToExternalLinks: true,
        defaultProtocol: 'http://',
        validate: function (url) {

            return /^(?:(?:https?|ftp):\/\/)?(?:\/)?(?:[^@\n]+@)?(?:www\.)?[^.]+\.[^.]+/.test(url);
        },
    },
    image: {
        resizeOptions: false,
        toolbar: []
    }
};

const FileRepository = {
    createUploadAdapter: (loader) => {
        return new UploadAdapter(loader);
    },
};
class UploadAdapter {
    constructor(loader) {
        this.loader = loader;
    }
    upload() {
        return new Promise((resolve) => {
            const imageUrl = this.loader.data;
            resolve({ default: imageUrl });
        });
    }
}

export function AddEditContestPlace() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [error, setError] = useState('');
    const { contestTypesList } = useSelector(state => state.contest);
    const { companiesList } = useSelector(state => state.employee);
    const [contest, setContest] = useState(ContestItem);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const { contestBaseId } = useParams();
    const [editLink, setEditLink] = useAdminMenuContext('');
    const [selectAll, setSelectAll] = useState(false);
    const [selectedOrganization, setSelectedOrganization] = useState([]);

    useEffect(() => {
        if (contestBaseId > 0) {
            dispatch(showLoading());
            getContestByBaseId(contestBaseId).then((response) => {
                let contestResponse = response.data.data;
                setContest(contestResponse);
                setEditLink(`/contest`);
                if (companiesList.length == contestResponse.contestCompanies.length) {
                    setSelectAll(true);
                }
                setSelectedOrganization(contestResponse.contestCompanies);
                console.log(editLink)
            }).catch((error) => {
                console.error("Error fetching contest:", error);
            }).finally(() => {
                dispatch(hideLoading());
            });
        }
        else {
            setEditLink('');
        }

    }, []);


    const [validation, setValidation] = useState({
        contestTitle: true,
        contestSubTitle: true,
        contestType: true,
        contestOrganization: true
    });

    useEffect(() => {
        document.title = 'Contest  | CWP Employee Portal';
        dispatch(getContestTypes());
        dispatch(getCompanies());
    }, []);

    const handleContestSave = () => {
        dispatch(showLoading());
        var isValid = true;
        contest.contestCompanies = selectedOrganization;

        let validate = {
            contestTitleError: '',
            contestSubTitleError: '',
            contestTypeError: '',
            contestOrganizationError: true,

        };
        if (contest == null || contest.title == null || contest.title == "") {
            validate.contestTitle = false;
            validate.contestTitleError = "Title is required";
            isValid = false;
        }
        if (contest == null || contest.subTitle == null || contest.subTitle == "") {
            validate.contestSubTitle = false;
            validate.contestSubTitleError = "Sub Title is required";
            isValid = false;
        }
        if (!contest.contestTypeId || contest.contestTypeId === 0) {
            validate.contestType = false;
            validate.contestTypeError = "Type is required";
            isValid = false;
        }

        if (contest == null || contest.contestCompanies == null || contest.contestCompanies == "") {
            validate.contestOrganization = false;
            validate.contestOrganizationError = "At least select one organization";
            isValid = false;
        }

        setValidation({ ...validation, ...validate });
        if (isValid == false) {
            dispatch(hideLoading());
            return;
        }
        addUpdateContest(contest)
            .then((response) => {
                if (response.data.success == false) {
                    dispatch(hideLoading());
                    setError(response.data.message);
                    return;
                }
                if (response.data.success) {
                    dispatch(hideLoading());
                    navigate('/siteadmin/contest');
                }
            })
            .catch((err) => {
                dispatch(hideLoading());
                if (err.response.data && err.response.data.message) {
                    setError(err.response.data.message);
                } else {
                    setError(err.response.responseText);
                }
            });
    };

    const handlePaste = (event, editor, data) => {
        event.stop();
        const plainText = data.dataTransfer.getData('text/plain');
        editor.model.change((writer) => {
            writer.insertText(plainText, editor.model.document.selection.getFirstPosition());
        });
        const updatedContent = editor.getData();
        setContest((prevEvent) => ({ ...prevEvent, content: updatedContent }));
        setIsInitialLoad(false);
    };
    const handleContestType = (e) => {
        const selectedType = parseInt(e.target.value);

        setContest(prevContest => {
            let updatedContest = {
                ...prevContest,
                contestTypeId: selectedType
            };

            if (selectedType !== 1) {
                updatedContest.ctaText = '';
                updatedContest.ctaUrl = '';
            }

            if (selectedType !== 2) {
                updatedContest.media = null;
                updatedContest.mediaId = null;
            }

            if (selectedType !== 3) {
                updatedContest.content = '';
            }

            return updatedContest;
        });
    };

    const handleAllCheckboxToggle = (e) => {
        const isChecked = e.target.checked;
        setSelectAll(isChecked);
        const updatedSelectedOrg = isChecked
            ? companiesList.map(company => ({ companyId: company.id }))
            : [];
        setSelectedOrganization(updatedSelectedOrg);
    };

    const handleOrganizationCompanyToggle = (e, companyId) => {
        const checked = e.target.checked;
        let updatedOrganization;

        if (checked) {
            updatedOrganization = [...selectedOrganization, { companyId }];
            if (companiesList.length == updatedOrganization.length) {
                setSelectAll(true);
            }
        } else {
            updatedOrganization = selectedOrganization.filter(item => item.companyId !== companyId);
            if (selectAll) {
                setSelectAll(false);
            }
        }

        setSelectedOrganization(updatedOrganization);
    }

    //const isActionType = contest.contestTypeId === 1;
    const isResultImageType = contest.contestTypeId === 2;
    const isResultHtmlType = contest.contestTypeId === 3;
    return (
        <div className="admin-page-wrap">
            <div className="admin-top-bar-wrap">
                <div className="admin-top-bar-left">
                    <Link
                        className="admin-top-bar-back"
                        to={'/siteadmin/contest'}
                    >
                        Back
                    </Link>
                </div>
            </div>
            <div className="admin-page-content">
                <h1 className="admin-page-heading">Add/Edit Contest</h1>
                <AdminError
                    message={error}
                    onClose={() => {
                        setError('');
                    }}
                ></AdminError>
                <div className="admin-section admin-section-narrow">
                    <div className="admin-section-row">
                        <div className="admin-section-cell">
                            <label className="admin-radio-label inline label-nowrap">
                                <input
                                    className="admin-inline-checkbox"
                                    type="radio"
                                    id="Active"
                                    name="visibility"
                                    checked={contest.visibility === 0}
                                    onChange={() => setContest({ ...contest, visibility: 0 })}
                                />
                                Active
                            </label>
                        </div>
                        <div className="admin-section-cell">
                            <label className="admin-radio-label inline">
                                <input
                                    className="admin-inline-checkbox"
                                    type="radio"
                                    id="Inactive"
                                    name="visibility"
                                    checked={contest.visibility === 2}
                                    onChange={() => setContest({ ...contest, visibility: 2 })}
                                />
                                Inactive
                            </label>
                        </div>
                    </div>

                    <div className="admin-section-row">
                        <div className="admin-section-cell wide">
                            <AdminTextInput
                                label="Title"
                                id="title-contest"
                                value={contest?.title ?? ''}
                                isRequired={true}
                                onChange={(value) => {
                                    setContest({ ...contest, title: value });
                                    setValidation({ ...validation, contestTitle: value != '' });
                                }}
                                validated={validation.contestTitle}
                                requiredText={validation.contestTitleError}
                            />
                        </div>
                        <div className="admin-section-cell wide">
                            <AdminTextInput
                                label="SubTitle"
                                id="subtitle-contest"
                                value={contest?.subTitle ?? ''}
                                isRequired={true}
                                onChange={(value) => {
                                    setContest({ ...contest, subTitle: value });
                                    setValidation({ ...validation, subTitle: value != '' });
                                }}
                                validated={validation.contestSubTitle}
                                requiredText={validation.contestSubTitleError}
                            />
                        </div>
                    </div>
                    <div className="admin-section-row">
                        <div className="admin-section-cell full">
                            <label className="admin-default-label">
                                Organization<span>*</span>
                            </label>
                            {!validation.contestOrganization && (
                                <p className="input-validation-error"><span className="validation-error-message">{validation.contestOrganizationError}</span></p>
                            )}
                            <div className="admin-column-wrap auto-columns addevents-auto-checkbox">
                                <label className="admin-checkbox-label inline">
                                    <input
                                        className="admin-inline-checkbox"
                                        type="checkbox"
                                        checked={selectAll}
                                        onChange={handleAllCheckboxToggle}
                                    ></input>
                                    All
                                </label>
                                {companiesList && companiesList.map(company => (
                                    <label
                                        className="admin-checkbox-label inline"
                                        key={company?.id}>
                                        <input
                                            className="admin-inline-checkbox"
                                            type="checkbox"
                                            checked={selectedOrganization.some(x => x.companyId === company.id)}
                                            onChange={(e) => {
                                                handleOrganizationCompanyToggle(e, company.id);
                                                setValidation({ ...validation, contestOrganization: e != '' });
                                            }}></input>
                                        {company.abbreviatedName}
                                    </label>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="admin-section-row">
                        <div className={`admin-section-cell wide ${!validation.contestType ? 'input-validation-error' : ''}`}>
                            <label className="admin-default-label">
                                Type*
                            </label>
                            <select className="admin-default-select" onChange={handleContestType} value={contest.contestTypeId}>
                                <option value="0" disabled hidden > Please Select a Type </option>
                                {contestTypesList
                                    .map((contestType) =>
                                        <option key={contestType.id} value={contestType.id}>
                                            {contestType.name}
                                        </option>
                                    )
                                }
                            </select>

                            {!validation.contestType && (
                                <p className="input-validation-error"><span className="validation-error-message">{validation.contestTypeError}</span></p>
                            )}
                        </div>
                    </div>
                    <div className="admin-section-row">
                        <div className="admin-section-cell wide">
                            <AdminTextInput
                                label="CTA Text"
                                id="ctaText-contest"
                                value={contest?.ctaText ?? ''}
                                onChange={(value) => {
                                    setContest({ ...contest, ctaText: value });

                                }}
                            />
                        </div>
                        <div className="admin-section-cell wide">
                            <div className="admin-default-input-text-wrap">
                                <label className="admin-default-label" htmlFor="ctaUrl-contest">
                                    CTA URL (Internal links should start with {'"/"'} i.e. {'/marketplace'})
                                </label>
                                <input
                                    className="admin-default-input-text"
                                    type="text"
                                    id="ctaUrl-contest"
                                    value={contest?.ctaUrl ?? ''}
                                    onChange={(e) => {
                                        setContest((prevContest) => ({
                                            ...prevContest,
                                            ctaUrl: e.target.value
                                        }));
                                    }}
                                    onBlur={(e) => { 
                                        let processedValue = e.target.value.trim();

                                        if (processedValue) { 
                                            if (!processedValue.startsWith("/")) {  
                                                if (
                                                    !processedValue.startsWith("https://") &&
                                                    !processedValue.startsWith("http://")
                                                ) {
                                                    processedValue = `https://${processedValue}`;
                                                }
                                            }
                                        }

                                        setContest((prevContest) => ({
                                            ...prevContest,
                                            ctaUrl: processedValue
                                        }));
                                    }}
                                />
                            </div>
                        </div>

                    </div>
                    {isResultImageType && (<div className="admin-section-row circle">
                        <div className="admin-section-cell full">
                            <p className="admin-section-small-headline">Image/Video</p>
                            <MediaUploader
                                requireAltText={false}
                                imageOnly={true}
                                allowGallery={false}
                                forceCrop={true}
                                isPlaceHolder={false}
                                mediaItems={(contest?.media != undefined && contest?.media !== null ? [contest?.media] : [])}
                                saveMediaItems={(mediaItems) => {
                                    setContest({
                                        ...contest,
                                        media: (mediaItems[0] != undefined && mediaItems[0] !== null) ? mediaItems[0] : null,
                                        mediaId: (mediaItems[0] != undefined && mediaItems[0] !== null) ? mediaItems[0].id : null
                                    })
                                }}
                            />
                        </div>
                    </div>
                    )}
                    {isResultHtmlType && (<div className="admin-section-row">
                        <div
                            className={
                                'admin-section-cell extra-wide'
                            }
                        >
                            <label className="admin-default-label" htmlFor="short-desc">
                                Content
                            </label>
                            <CKEditor
                                editor={Editor}
                                config={ckEditorConfig}
                                data={contest && contest.content || ''}
                                onReady={(editor) => {
                                    editor.plugins.get('FileRepository').createUploadAdapter = (loader) =>
                                        FileRepository.createUploadAdapter(loader);
                                    editor.editing.view.document.on('clipboardInput', (evt, data) => {
                                        handlePaste(evt, editor, data);
                                    });
                                }}
                                onChange={(contest, editor) => {
                                    const data = editor.getData();
                                    setContest((prevContest) => ({ ...prevContest, content: data }));
                                    if (!isInitialLoad) {
                                        console.log("data", data);
                                    }
                                    setIsInitialLoad(false);
                                }}
                                onPaste={handlePaste}
                            />
                        </div>
                    </div>
                    )}
                </div>

                <div className="admin-floating-button-wrap">
                    <button
                        className="admin-floating-button"
                        onClick={() =>
                            navigate('/siteadmin/contest')
                        }
                    >
                        Cancel
                    </button>
                    <button
                        className="admin-floating-button power"
                        onClick={handleContestSave}
                    >
                        Save Changes
                    </button>
                </div>
            </div>
        </div>
    );
} 